import script from "./BookingSuccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingSuccess.vue?vue&type=script&setup=true&lang=ts"

import "./BookingSuccess.vue?vue&type=style&index=0&id=66063526&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66063526"]])

export default __exports__